export const isNitroEnvironment = ()=>window.location.hostname.includes('nitro.run');
export const isOrbitsEnvironment = ()=>window.location.hostname.includes('orbits.run');
export const isShardTestEnvironment = ()=>window.location.hostname.includes('shardtest');
const testingOrbitsEnvironmentPattern = /^\d{8}-\d{6}\.orbits\.run$/;
export const isTestingOrbitsEnvironment = ()=>testingOrbitsEnvironmentPattern.test(window.location.hostname);
export const isNitroOrLocalEnvironment = ()=>{
    return isNitroEnvironment() || window.location.hostname.includes('localhost');
};
